import { STM } from '../context/types';

export const pt_ptStatements : STM[]  = [
  {
    "id":1,
    "valueKey": "samen1",
    "title":"trabalhar juntos é frequente",
    "title_360_leadership": "estimula o trabalho em equipe",
    "title_360_workenv": "o trabalho em equipe é frequente",
    "preferredType": "leadership"
  },
  {
    "id":2,
    "valueKey": "samen2",
    "title":"os interesses da equipe vêm antes dos interesses individuais",
    "title_360_leadership": "prioriza o sucesso da equipe antes do seu próprio",
    "title_360_workenv": "os interesses da equipe têm prioridade sobre os interesses individuais",
    "preferredType": "workenv"
  },
  {
    "id":3,
    "valueKey": "samen3",
    "title":"cada pessoa faz o seu melhor pela equipe",
    "title_360_leadership": "se envolve com a sua equipe",
    "title_360_workenv": "cada um dá o seu melhor pela equipe",
    "preferredType": "leadership"
  },
  {
    "id":4,
    "valueKey": "conf1",
    "title":"uma opinião pessoal não é compartilhada se isso puder dar origem a um conflito",
    "title_360_leadership": "não expressa sua opinião se isso pode levar a um conflito",
    "title_360_workenv": "uma opinião pessoal não é compartilhada se isso puder levar a um conflito",
    "preferredType": "workenv"
  },
  {
    "id":5,
    "valueKey": "conf2",
    "title":"todo esforço é feito para manter a paz",
    "title_360_leadership": "faz tudo para evitar disputas",
    "title_360_workenv": "todos os esforços são feitos para manter a paz",
    "preferredType": "leadership"
  },
  {
    "id":6,
    "valueKey": "conf3",
    "title":"as regras e padrões existentes são seguidos com rigor",
    "title_360_leadership": "assegura que todos respeitem as regras e normas",
    "title_360_workenv": "as regras e padrões existentes são seguidos com precisão",
    "preferredType": "workenv"
  },
  {
    "id":7,
    "valueKey": "erken1",
    "title":"as pessoas são respeitadas pelos colegas de trabalho e gestores",
    "title_360_leadership": "garante um ambiente onde todos se respeitem mutuamente",
    "title_360_workenv": "as pessoas são respeitadas pelos colegas e gerentes",
    "preferredType": "workenv"
  },
  {
    "id":8,
    "valueKey": "erken2",
    "title":"é prestado reconhecimento pelo trabalho árduo",
    "title_360_leadership": "reconhece o esforço dos funcionários",
    "title_360_workenv": "o trabalho árduo é reconhecido",
    "preferredType": "workenv"
  },
  {
    "id":9,
    "valueKey": "erken3",
    "title":"o empenho é valorizado e apreciado",
    "title_360_leadership": "valoriza o esforço dos funcionários",
    "title_360_workenv": "o empenho é valorizado e apreciado",
    "preferredType": "leadership"
  },
  {
    "id":10,
    "valueKey": "zorg1",
    "title":"cada pessoa sempre faz o que é certo de acordo com os outros",
    "title_360_leadership": "é bondoso e respeitoso",
    "title_360_workenv": "sempre se faz o certo em relação aos outros",
    "preferredType": "leadership"
  },
  {
    "id":11,
    "valueKey": "zorg2",
    "title":"cada pessoa contribui para o bem-estar dos outros",
    "title_360_leadership": "cria um ambiente onde todos se sentem bem",
    "title_360_workenv": "contribui-se para o bem-estar dos outros",
    "preferredType": "workenv"
  },
  {
    "id":12,
    "valueKey": "zorg3",
    "title":"as pessoas se ajudam mutuamente",
    "title_360_leadership": "cria um clima de cooperação",
    "title_360_workenv": "as pessoas se ajudam mutuamente",
    "preferredType": "leadership"
  },
  {
    "id":13,
    "valueKey": "gelijk1",
    "title":"todos são tratados igualmente",
    "title_360_leadership": "trata todos de maneira igual",
    "title_360_workenv": "todos são tratados de forma igual",
    "preferredType": "workenv"
  },
  {
    "id":14,
    "valueKey": "gelijk2",
    "title":"idade, origem ou sexo não importam",
    "title_360_leadership": "não faz diferenças com base na idade, origem ou sexo",
    "title_360_workenv": "a idade, origem ou sexo não importam",
    "preferredType": "workenv"
  },
  {
    "id":15,
    "valueKey": "gelijk3",
    "title":"cada pessoa é julgada por suas ações, não por seu caráter",
    "title_360_leadership": "avalia os funcionários com base nas suas ações",
    "title_360_workenv": "é-se julgado pelas ações, não pelo caráter",
    "preferredType": "leadership"
  },
  {
    "id":16,
    "valueKey": "zelfsturing1",
    "title":"é possível, na maioria das vezes, agir por conta própria",
    "title_360_leadership": "permite que cada funcionário tenha um alto grau de autonomia",
    "title_360_workenv": "é possível, em grande parte, agir por conta própria",
    "preferredType": "workenv"
  },
  {
    "id":17,
    "valueKey": "zelfsturing2",
    "title":"cada pessoa pode determinar seu próprio método de trabalho",
    "title_360_leadership": "permite que cada funcionário defina seu próprio estilo de trabalho",
    "title_360_workenv": "pode-se determinar o próprio método de trabalho",
    "preferredType": "leadership"
  },
  {
    "id":18,
    "valueKey": "zelfsturing3",
    "title":"cada pessoa pode planejar como fazer seu trabalho",
    "title_360_leadership": "permite que cada funcionário defina seu próprio horário de trabalho",
    "title_360_workenv": "pode-se planejar por si mesmo como fazer o próprio trabalho",
    "preferredType": "workenv"
  },
  {
    "id":19,
    "valueKey": "macht1",
    "title":"Eu posso influenciar o comportamento dos outros",
    "title_360_leadership": "influencia meu trabalho",
    "preferredType": "leadership"
  },
  {
    "id":20,
    "valueKey": "macht2",
    "title":"Sou eu quem decide sobre as coisas a serem feitas",
    "title_360_leadership": "determina o que precisa ser feito",
    "preferredType": "leadership"
  },
  {
    "id":21,
    "valueKey": "macht3",
    "title":"Eu determino o que acontece",
    "title_360_leadership": "decide o que precisa ser feito",
    "preferredType": "disabled"
  },
  {
    "id":22,
    "valueKey": "voorspelbaar1",
    "title":"existe estrutura e regularidade",
    "title_360_leadership": "garante a estrutura e a regularidade",
    "title_360_workenv": "há estrutura e regularidade",
    "preferredType": "workenv"
  },
  {
    "id":23,
    "valueKey": "voorspelbaar2",
    "title":"as coisas geralmente ocorrem conforme planejado",
    "title_360_leadership": "assegura que as coisas geralmente ocorram como planejado",
    "title_360_workenv": "as coisas geralmente ocorrem conforme planejado",
    "preferredType": "leadership"
  },
  {
    "id":24,
    "valueKey": "voorspelbaar3",
    "title":"valores e formas de pensamento tradicionais podem ser mantidos",
    "title_360_leadership": "garante o respeito às valores e pensamentos tradicionais",
    "title_360_workenv": "os valores e formas de pensar tradicionais podem ser mantidos",
    "preferredType": "workenv"
  },
  {
    "id":25,
    "valueKey": "prestatie1",
    "title":"é possível fazer o nosso melhor",
    "title_360_leadership": "encoraja os funcionários a darem o melhor de si",
    "title_360_workenv": "é possível dar o seu melhor",
    "preferredType": "leadership"
  },
  {
    "id":26,
    "valueKey": "prestatie2",
    "title":"uma pessoa pode demonstrar todo o seu potencial",
    "title_360_leadership": "encoraja os funcionários a mostrar o que podem fazer",
    "title_360_workenv": "pode-se demonstrar todo o seu potencial",
    "preferredType": "workenv"
  },
  {
    "id":27,
    "valueKey": "prestatie3",
    "title":"uma pessoa pode se destacar no seu trabalho",
    "title_360_leadership": "encoraja os funcionários a superarem-se",
    "title_360_workenv": "pode-se se destacar no próprio trabalho",
    "preferredType": "workenv"
  },
  {
    "id":28,
    "valueKey": "zelfontplooi1",
    "title":"pode-se aprender coisas novas continuamente",
    "title_360_leadership": "encoraja a formação contínua",
    "title_360_workenv": "pode-se aprender continuamente novas coisas",
    "preferredType": "workenv"
  },
  {
    "id":29,
    "valueKey": "zelfontplooi2",
    "title":"pode-se aprofundar seus conhecimentos",
    "title_360_leadership": "encoraja os funcionários a aprofundar suas habilidades",
    "title_360_workenv": "pode-se aprofundar o próprio conhecimento",
    "preferredType": "leadership"
  },
  {
    "id":30,
    "valueKey": "zelfontplooi3",
    "title":"pode-se expandir continuamente seu desenvolvimento pessoal",
    "title_360_leadership": "ajuda os outros a se desenvolver",
    "title_360_workenv": "pode-se expandir continuamente o próprio desenvolvimento pessoal",
    "preferredType": "workenv"
  },
  {
    "id":31,
    "valueKey": "duurzaam1",
    "title":"trabalho de boa qualidade é entregue",
    "title_360_leadership": "assegura que a equipe entrega um trabalho de qualidade",
    "title_360_workenv": "é entregue um trabalho de boa qualidade",
    "preferredType": "leadership"
  },
  {
    "id":32,
    "valueKey": "duurzaam2",
    "title":"os clientes e/ou outros no negócio são respeitados",
    "title_360_leadership": "encoraja a equipe a respeitar os clientes e outras relações",
    "title_360_workenv": "os clientes e/ou outros no negócio são respeitados",
    "preferredType": "workenv"
  },
  {
    "id":33,
    "valueKey": "duurzaam3",
    "title":"tem-se consideração pelas pessoas, segurança e meio ambiente",
    "title_360_leadership": "assegura que a equipe se preocupa com a segurança e o ambiente",
    "title_360_workenv": "há consideração pelas pessoas, segurança e meio ambiente",
    "preferredType": "workenv"
  },
  {
    "id":34,
    "valueKey": "integriteit1",
    "title":"a responsabilidade é assumida por nossas ações",
    "title_360_leadership": "assegura que a equipe assume a responsabilidade por seus atos",
    "title_360_workenv": "assume-se a responsabilidade pelas próprias ações",
    "preferredType": "workenv"
  },
  {
    "id":35,
    "valueKey": "integriteit2",
    "title":"as pessoas são honestas",
    "title_360_leadership": "é honesto",
    "title_360_workenv": "as pessoas são honestas",
    "preferredType": "workenv"
  },
  {
    "id":36,
    "valueKey": "integriteit3",
    "title":"a confidencialidade é respeitada",
    "title_360_leadership": "trata a informação pessoal e confidencial com cuidado",
    "title_360_workenv": "a confidencialidade é respeitada",
    "preferredType": "leadership"
  },
  {
    "id":37,
    "valueKey": "innovatie1",
    "title":"coisas novas podem ser experimentadas",
    "title_360_leadership": "encoraja os funcionários a experimentarem novas formas de trabalho",
    "title_360_workenv": "pode-se experimentar coisas novas",
    "preferredType": "leadership"
  },
  {
    "id":38,
    "valueKey": "innovatie2",
    "title":"temos muitas experiências novas",
    "title_360_leadership": "encoraja os funcionários a adquirirem novas experiências",
    "title_360_workenv": "têm-se muitas novas experiências",
    "preferredType": "workenv"
  },
  {
    "id":39,
    "valueKey": "innovatie3",
    "title":"pode-se procurar desafios",
    "title_360_leadership": "encoraja os funcionários a procurarem novos desafios",
    "title_360_workenv": "podem-se buscar novos desafios",
    "preferredType": "leadership"
  },
  {
    "id":40,
    "valueKey": "daadkracht1",
    "title":"uma pessoa toma a iniciativa de enfrentar tarefas",
    "title_360_leadership": "encoraja os funcionários a iniciar tarefas por conta própria",
    "title_360_workenv": "toma-se a iniciativa de enfrentar tarefas",
    "preferredType": "workenv"
  },
  {
    "id":41,
    "valueKey": "daadkracht2",
    "title":"fazer todo o possível para obter resultados é altamente priorizado",
    "title_360_leadership": "assegura que os resultados sejam alcançados",
    "title_360_workenv": "fazer tudo o possível para obter resultados é uma alta prioridade",
    "preferredType": "leadership"
  },
  {
    "id":42,
    "valueKey": "daadkracht3",
    "title":"é feito todo esforço possível para atingir os objetivos definidos",
    "title_360_leadership": "faz tudo para alcançar os objetivos",
    "title_360_workenv": "são feitos todos os esforços possíveis para alcançar os objetivos estabelecidos",
    "preferredType": "leadership"
  }
]

export const extra360Pt_PtStatements : Omit<STM, 'title'>[] = [
    // Additional statements used in Actual360 but not IdealClassic
    {
      id: 43,
      valueKey: 'daadkracht4',
      title_360_leadership:
          'toma decisões',
      preferredType: 'leadership',
    },
    {
      id: 44,
      valueKey: 'gelijk4',
      title_360_leadership:
          'respeita e valoriza as diferenças entre os membros da equipa',
      preferredType: 'leadership',
    },
    {
      id: 45,
      valueKey: 'prestatie4',
      title_360_leadership:
          'dá feedback construtivo',
      preferredType: 'leadership',
    },
]
